const defaultOptions = {
  minute: '2-digit',
  hour: '2-digit',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
}

const formatDateTime = (dateInMs, options = defaultOptions) => {
  const { minute, hour, day, month, year } = options
  const today = new Date(Date.now()).toLocaleDateString('de', {
    day,
    month,
    year
  })
  const date = new Date(dateInMs).toLocaleDateString('de', { day, month, year })
  const time = new Date(dateInMs).toLocaleTimeString('de', { hour, minute })
  if (date === today) return ['Heute', time]
  return [date, time]
}

export default formatDateTime



// WEBPACK FOOTER //
// ./src/utils/formatDateTime.js